import {
  CreateCompanyDto,
  UpdateCompanyDto,
  RecordStatus,
} from "./../../data/service-proxies";
import { createDefaultHosDataSavedAction } from "./../actions/defaultHosData";
import {
  APP_DATA_RECEIVED,
  createAppDataReceivedAction,
} from "./../actions/appData";
import { take, put, all, takeEvery, fork } from "redux-saga/effects";
import { CRUD_CREATE_SUCCESS, Record, CRUD_UPDATE_SUCCESS } from "react-admin";
import resourceNames from "../../data/resourceNames";

export function* defaultHosDataSagas() {
  yield all([saveDefaultDataFromAppDataSaga, companyCrudSaga].map(fork));
}

function* saveDefaultDataFromAppDataSaga() {
  const appData: ReturnType<typeof createAppDataReceivedAction> = yield take(
    APP_DATA_RECEIVED
  );

  const { companies } = appData.payload;
  if (!companies) {
    return;
  }

  yield all(
    companies.map(
      (company) =>
        company.id &&
        company.defaultHosData &&
        put(
          createDefaultHosDataSavedAction({
            companyId: company.id,
            ...company.defaultHosData,
          })
        )
    )
  );
}

function* companyCrudSaga() {
  yield all([onCompanyCreateSaga, onCompanyEditSaga].map(fork));
}

function* onCompanyCreateSaga() {
  yield takeEvery(CRUD_CREATE_SUCCESS, handleCompanyCreate);
}

function* onCompanyEditSaga() {
  yield takeEvery(CRUD_UPDATE_SUCCESS, handleCompanyUpdate);
}

function* handleCompanyCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_COMPANIES) {
    return;
  }

  const company = action.requestPayload.data as CreateCompanyDto;
  yield put(
    createDefaultHosDataSavedAction({
      companyId: action.payload.data.id as number,
      timeZoneId: company.homeTerminalTimeZone!,
      cycleRules: company.cycleRules!,
      thirtyMinuteBreakException: company.thirtyMinuteBreakException!,
      twentyFourHourCycleReset: company.twentyFourHrCycleReset!,
      dvirWarnings: company.dvirWarnings!,
      cargoType: company.cargoType!,
      odometer: company.odometer,
    })
  );
}

function* handleCompanyUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_COMPANIES) {
    return;
  }

  if (action.payload.data?.status !== RecordStatus.Active) {
    return;
  }

  const company = action.requestPayload.data as UpdateCompanyDto;
  yield put(
    createDefaultHosDataSavedAction({
      companyId: company.id!,
      timeZoneId: company.homeTerminalTimeZone!,
      cycleRules: company.cycleRules!,
      thirtyMinuteBreakException: company.thirtyMinuteBreakException!,
      twentyFourHourCycleReset: company.twentyFourHrCycleReset!,
      dvirWarnings: company.dvirWarnings!,
      cargoType: company.cargoType!,
      odometer: company.odometer,
    })
  );
}
